import { random, sample, sampleSize } from 'lodash'

/**
 * Undocumented set of unique strings. May change at any time, so don’t make assumptions about its contents.
 */
// The NATO phonetic alphabet
export const stringSet = [
  'alfa',
  'bravo',
  'charlie',
  'delta',
  'echo',
  'foxtrot',
  'golf',
  'hotel',
  'india',
  'juliett',
  'kilo',
  'lima',
  'mike',
  'november',
  'oscar',
  'papa',
  'quebec',
  'romeo',
  'sierra',
  'tango',
  'uniform',
  'victor',
  'whiskey',
  'xray',
  'yankee',
  'zulu',
] as const

/**
 * Returns a short, random (but not unique) string.
 *
 * @example string()
 * //=> "tango"
 */
export const string = () => sample(stringSet)!

/**
 * An array of `min(n, stringSet.length)` `string()` values.
 *
 * @example strings(3)
 * //=> ["tango", "charlie", "lima"]
 */
export const strings = (n: number) => sampleSize(stringSet, n)

/**
 * Returns a random (but not unique) string of undocumented length. It can be assumed to have at least 150 graphemes.
 *
 * @example longString()
 * //=> "victor foxtrot alfa mike [...]"
 */
export const longString = () => {
  const length = random(20, 50)
  return strings(length).join(' ')
}
